import { render, staticRenderFns } from "./annotation.vue?vue&type=template&id=6bedfbf2&scoped=true"
import script from "./annotation.vue?vue&type=script&lang=js"
export * from "./annotation.vue?vue&type=script&lang=js"
import style0 from "./annotation.vue?vue&type=style&index=0&id=6bedfbf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bedfbf2",
  null
  
)

export default component.exports